import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FETCH_COIN,
  FETCH_COIN_LOG,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'coin' })
export default class Coin extends VuexModule {
  @Action
  async FetchCoinReport(user: object) {
    return Vue.axios({
      url: BASE_URL + FETCH_COIN,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const item = data.data;
          return item;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }

  @Action
  async FetchCoinLog(user: object) {
    return Vue.axios({
      url: BASE_URL + FETCH_COIN_LOG,
      data: user,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const item = data.data;
          return item;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
